@if (isVisible) {
  <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
}